import { WorkflowConfigFieldInputType } from '../enums';
import { WorkflowConfigFieldInput } from '../interfaces/workflow-config/workflow-config-field-input.interface';

export function getEffectiveInputType(
    field: Partial<Pick<WorkflowConfigFieldInput, 'type' | 'typeForValidation'>>
): WorkflowConfigFieldInputType | undefined {
    return field.typeForValidation ?? field.type;
}

export function isNumericInputType(inputType: WorkflowConfigFieldInputType | undefined): boolean {
    return (
        inputType === WorkflowConfigFieldInputType.NUMBER ||
        inputType === WorkflowConfigFieldInputType.DECIMAL ||
        inputType === WorkflowConfigFieldInputType.FLOAT
    );
}
